import React from "react";
import ReactDOM from "react-dom/client";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import "./index.css";
import App from "./App";

// Windows'ta bayrak emojileri (🇮🇹) glyph olmadığı için "IT" gibi harflerle görünür.
// Bu polyfill "Twemoji Country Flags" fontunu enjekte eder; index.css'te font-family'nin
// başına eklendiği için native <select> dahil her yerde bayraklar render olur.
polyfillCountryFlagEmojis();

// Web Push için service worker kaydı (destek yoksa/başarısızsa sessizce geç).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}

// Silence the noisy (harmless) ResizeObserver loop error some libs trigger.
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
